// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { updateCart } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

export interface DeleteOrderParameter { 
    cart: CartModel
}

type HandlerType = ApiHandlerDiscreteParameter<
    DeleteOrderParameter & HasOnSuccess<CartModel> & HasOnError<string>,
    UpdateCartApiParameter,
    any
>;
export const DispatchBeginDeleteOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderApprovalDetails/BeginDeleteOrder",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    if (props.parameter.cart) {
        props.apiParameter = {
            cart: {
                ...props.parameter.cart,
                properties: {
                    ...props.parameter.cart.properties,
                    orderApprovalUpdatedStatus: "Declined",
                },
            },
        };
    }
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await updateCart(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const currentCartId = state.data.carts.currentId;

    if (currentCartId !== state.pages.orderApprovalDetails.cartId) {
        return;
    }

    props.dispatch(loadCurrentCart());
};

export const DispatchOrderApprovalsReset: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const DispatchCompleteDeleteOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderApprovalDetails/CompleteDeleteOrder",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginDeleteOrder,
    PopulateApiParameter,
    SendDataToApi,
    LoadCart,
    DispatchOrderApprovalsReset,
    DispatchCompleteDeleteOrder,
    ExecuteOnSuccessCallback,
];

const deleteOrder = createHandlerChainRunner(chain, "DeleteOrder");
export default deleteOrder;
